import { render, staticRenderFns } from "./NumberInputAdvancedProps.vue?vue&type=template&id=054ba1f2&"
import script from "./NumberInputAdvancedProps.vue?vue&type=script&lang=js&"
export * from "./NumberInputAdvancedProps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports